import React, { FC } from 'react'

import dayjs from 'dayjs'
import { Box, IconButton } from '@mui/material'
import Typography from '@mui/material/Typography'

import { getIcon, getTitle } from './notificationsHelpers'
import { BaseNotification } from '@app/types/notifications'
import { AlertCloseSvg } from '@app/pages/Dashboard/assets/icons'
import { NotDate, NotTitle, NotWrapper, NotMessage } from './styled'
import { useTimeController } from '@app/hooks/contexts/timeController/TimeControllerContext'

interface NotificationProps {
	readonly notification: BaseNotification
	readonly onClose?: React.MouseEventHandler<HTMLButtonElement>
}

const Notification: FC<NotificationProps> = ({
	notification,
	onClose,
}: NotificationProps) => {
	const {
		formatters: { tdf1 },
	} = useTimeController()
	const full =
		notification?.type === 'latestTasks' ||
		notification?.type === 'latestCalenderEvents'

	const isToday = dayjs(notification?.dueDate).isToday()

	return (
		<NotWrapper
			variant={'filled'}
			icon={getIcon(notification?.type)}
			sx={{
				pointerEvents: 'auto',
			}}
		>
			<Box
				sx={{
					display: 'flex',
					width: full ? '330px' : '280px',
					justifyContent: 'space-between',
				}}
			>
				<NotTitle>{getTitle(notification)}</NotTitle>

				<IconButton onClick={onClose}>{AlertCloseSvg}</IconButton>
			</Box>

			<NotMessage>{notification?.message}</NotMessage>

			<NotDate>
				<Typography>
					{isToday ? 'Today, ' : ''}
					{tdf1(notification?.dueDate)}
				</Typography>

				<Typography>
					{full ? dayjs(notification?.dueDate).fromNow() : ''}
				</Typography>
			</NotDate>
		</NotWrapper>
	)
}

export default Notification
